// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/(protected)/2fa-setup": [46,[2]],
		"/about": [47],
		"/(protected)/(admin)/admin-users": [6,[2,3]],
		"/(protected)/(admin)/admin-users/add": [8,[2,3]],
		"/(protected)/(admin)/admin-users/[id]": [7,[2,3]],
		"/(protected)/(admin)/analytics": [9,[2,3]],
		"/(protected)/(admin)/answers/[id]": [10,[2,3]],
		"/(protected)/(app)/app-assessments": [35,[2,4]],
		"/(protected)/(app)/app-assessments/[id]": [36,[2,4]],
		"/(protected)/(app)/app-chat": [37,[2,4]],
		"/(protected)/(app)/app-hints": [38,[2,4]],
		"/(protected)/(app)/app-hints/[id]": [39,[2,4]],
		"/(protected)/(app)/app-home": [40,[2,4]],
		"/(protected)/(admin)/app-users": [11,[2,3]],
		"/(protected)/(admin)/app-users/add": [13,[2,3]],
		"/(protected)/(admin)/app-users/[id]": [12,[2,3]],
		"/(protected)/(admin)/assessments": [14,[2,3]],
		"/(protected)/(admin)/assessments/add": [16,[2,3]],
		"/(protected)/(admin)/assessments/[id]": [15,[2,3]],
		"/(protected)/(app)/avatar": [41,[2,4]],
		"/(protected)/(admin)/chat-conversations": [17,[2,3]],
		"/(protected)/(admin)/chat-conversations/new": [19,[2,3]],
		"/(protected)/(admin)/chat-conversations/[id]": [18,[2,3]],
		"/(protected)/(admin)/data-manage": [20,[2,3]],
		"/(protected)/(admin)/docs": [21,[2,3]],
		"/forgot-password": [48],
		"/(protected)/(admin)/hints": [22,[2,3]],
		"/(protected)/(admin)/hints/add": [24,[2,3]],
		"/(protected)/(admin)/hints/[id]": [23,[2,3]],
		"/(protected)/(admin)/home": [25,[2,3]],
		"/(protected)/(admin)/images": [26,[2,3]],
		"/(protected)/(admin)/images/add": [28,[2,3]],
		"/(protected)/(admin)/images/[id]": [27,[2,3]],
		"/(protected)/(app)/information": [42,[2,4]],
		"/legal": [49],
		"/logout": [50],
		"/(protected)/(admin)/my-profile": [29,[2,3]],
		"/(protected)/(app)/pets": [43,[2,4]],
		"/(protected)/(admin)/questions/[id]": [30,[2,3]],
		"/reset-password": [51],
		"/(protected)/(app)/settings": [44,[2,4]],
		"/(protected)/(app)/statistics": [45,[2,4]],
		"/(protected)/(admin)/target-audiences": [31,[2,3]],
		"/(protected)/(admin)/target-audiences/add": [33,[2,3]],
		"/(protected)/(admin)/target-audiences/[id]": [32,[2,3]],
		"/(protected)/(admin)/translate": [34,[2,3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);